import { io, type Socket } from 'socket.io-client';

/**
 * One socket per tab, created lazily.
 *
 * Socket.IO is asked for the WebSocket transport first: polling works, but a
 * classroom of thirty tabs long-polling a small VPS is a self-inflicted wound.
 */
let socket: Socket | null = null;

export function getSocket(): Socket {
  socket ??= io({ path: '/socket.io', transports: ['websocket', 'polling'] });
  return socket;
}

/** Promise-shaped emit: every game event is a request with an acknowledgement. */
export function ask<T>(event: string, payload?: unknown, timeoutMs = 8000): Promise<T> {
  return new Promise((resolve, reject) => {
    const s = getSocket();
    const timer = setTimeout(() => reject(new Error(`${event} timed out`)), timeoutMs);
    s.emit(event, payload ?? {}, (response: T) => {
      clearTimeout(timer);
      resolve(response);
    });
  });
}
